import { constants } from '@yola/subscription-manager-js';

const { SubscriptionTerm } = constants;

export const PER_MONTH = 'perMonth';
export const PER_YEAR = 'perYear';
export const TOTAL = 'total';
export const MONTH = 'month';

export const API_TERM_VALUES = {
  [PER_MONTH]: SubscriptionTerm.MONTHLY,
  [PER_YEAR]: SubscriptionTerm.ANNUAL,
};
